module.exports = __webpack_public_path__ + "static/media/vinayak-profile.714b5608.png";